import { render, staticRenderFns } from "./records.vue?vue&type=template&id=261bb79a&scoped=true&"
import script from "./records.vue?vue&type=script&lang=js&"
export * from "./records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261bb79a",
  null
  
)

export default component.exports